import ServicesList from './ServicesList';

export default ServicesList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/ServicesList/index.js